import React from 'react'
import PropTypes from 'prop-types'

import { get, reject, isEmpty, isUndefined } from 'lodash'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Button, Paper, Typography } from '@material-ui/core'

import { CrestLoader } from '@scoir/college-image-components'

import sanitize from 'common/sanitize-html-helper'

const useStyles = makeStyles((theme) => ({
  collegeHeader: {
    width: '100%',
    wordWrap: 'break-word',
    marginBottom: theme.spacing(2),
  },
  collegeCrest: {
    width: '50px',
    height: '50px',
    marginRight: '10px',
  },
  link: {
    textAlign: 'start',
    margin: '20px 0',
  },
  ctaButton: {
    maxWidth: '60%',
    whiteSpace: 'pre-wrap',
  },
}))

const MessageDetails = ({ message }) => {
  const classes = useStyles()
  const link = get(message, 'Link')
  const linkLabel = get(message, 'LinkLabel')
  const scid = get(message, 'Scid')
  const hasLink = !isEmpty(link)
  const hasScid = !isUndefined(scid)
  const collegeName = get(message, 'CollegeName')
  const collegeLocation = reject([get(message, 'City'), get(message, 'State'), get(message, 'Country')], isEmpty).join(
    ', ',
  )
  const messageSubject = get(message, 'Subject')
  const messageBody = sanitize(get(message, 'Message', ''))

  return (
    <Paper
      elevation={0}
      component={Box}
      p={3}
    >
      <Box className={classes.collegeHeader}>
        <Box display="flex">
          {hasScid && (
            <CrestLoader
              className={classes.collegeCrest}
              scid={scid}
            />
          )}
          <Box>
            <Typography
              variant="body1"
              color="textPrimary"
            >
              {collegeName}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
            >
              {collegeLocation}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Typography variant="h6">{messageSubject}</Typography>
      <Typography
        variant="body1"
        dangerouslySetInnerHTML={{ __html: messageBody }}
      />
      {hasLink && (
        <div className={classes.link}>
          <Button
            className={classes.ctaButton}
            variant="contained"
            color="primary"
            component="a"
            href={link}
            rel="noopener noreferrer"
            target="_blank"
          >
            {linkLabel || 'Learn More'}
          </Button>
        </div>
      )}
    </Paper>
  )
}
MessageDetails.propTypes = {
  message: PropTypes.object.isRequired,
}

export default MessageDetails
